import { ActionSetting } from '../../../model/actionSetting';
import { ActionVariants } from './variants';

export const ActionSettingPreview = ({ value }: { value: ActionSetting }) => {
  if (value.type === 'action_list_dialog') {
    const Preview = ActionVariants['action_list_dialog']?.Preview;

    return <Preview value={value} />;
  }
  if (value.type === 'full_screen_dialog') {
    const Preview = ActionVariants['full_screen_dialog']?.Preview;

    return <Preview value={value} />;
  }
  if (value.type === 'message_box') {
    const Preview = ActionVariants['message_box']?.Preview;

    return <Preview value={value} />;
  }
  if (value.type === 'alert_dialog') {
    const Preview = ActionVariants['alert_dialog']?.Preview;

    return <Preview value={value} />;
  }
  if (value.type === 'open_link') {
    return null;
  }

  return null;
};
